const RoutePaths = {
	EXPLORE: { path: '/explore', label: 'Explore' },
	EXPLOREV2: { path: '/explorev2', label: 'ExploreV2' }
};

export default RoutePaths;
